module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/namba_sns_05-3e58c646d023362009c7df98c7cc5c38.jpg";